import { queryClient } from 'app/services/reactQuery';

import { OAB_ELIGIBILITY_QUERY_KEY } from './queryKeys';

// Toda gravação de OAB muda `has_oab`, e a captura lê a elegibilidade com
// staleTime de 10 min: sem isto, quem cadastra a OAB pelo perfil, pelo
// onboarding ou pelo monitoramento segue sendo convidado a cadastrá-la.
// Vive junto do `queryClient` singleton (o mesmo do `App.js`) porque os pontos
// de gravação são funções de API, fora de qualquer hook.
export function invalidateOabEligibility(): void {
  queryClient.invalidateQueries({ queryKey: OAB_ELIGIBILITY_QUERY_KEY });
}
